import {
  BaseThemeColorKey,
  BaseThemeColors,
  ColorPaletteKey,
  ThemeColorsVariationKey,
  Tier1DerivedThemeColorKey,
  Tier1DerivedThemeColors,
  Tier2DerivedThemeColorKey,
  Tier2DerivedThemeColors,
  Tier3DerivedThemeColorKey,
  Tier3DerivedThemeColors,
} from '@nucleus/types/web';

// NOTE: The order of the color is important, as they will be looped over in the order they are defined.
// Colors that depend on other colors for contrast should be defined after the colors they depend on.
// This is particularly important for button text and background colors, depending on the style of the
// button - text or background may need to be defined first.
export const THEME_COLORS_VARIATION_1: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.Color1,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.Color1,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.Color1,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.Color1,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorDark,
};

export const THEME_COLORS_VARIATION_2: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.Color2,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.Color2,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.Color2,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.Color2,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorDark,
};

export const THEME_COLORS_VARIATION_3: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.Color3,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.Color3,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.Color3,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.Color3,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorDark,
};

export const THEME_COLORS_VARIATION_4: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.Color4,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.Color4,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.Color4,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.Color6,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.Color4,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.Color5,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorDark,
};

export const THEME_COLORS_VARIATION_5: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorDark,
};

export const THEME_COLORS_VARIATION_6: BaseThemeColors = {
  [BaseThemeColorKey.Dark]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Light]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionBackgroundTexture]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.BlockBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.SectionText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionTextHeadline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionTextBody]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionTextOverline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.SectionTextByline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.CardText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardTextHeadline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardTextBody]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardTextOverline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.CardTextByline]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonPrimaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonPrimaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonTertiaryText]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonTertiaryBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.ButtonSecondaryAltBackground]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.ButtonSecondaryAltText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.NavigationBackground]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.NavigationText]: ColorPaletteKey.ColorDark,
  [BaseThemeColorKey.Logo]: ColorPaletteKey.ColorLight,
  [BaseThemeColorKey.LogoNavigation]: ColorPaletteKey.ColorLight,
};

export const ThemeColorsVariations: Record<ThemeColorsVariationKey, BaseThemeColors> = {
  'variation-1': THEME_COLORS_VARIATION_1,
  'variation-2': THEME_COLORS_VARIATION_2,
  'variation-3': THEME_COLORS_VARIATION_3,
  'variation-4': THEME_COLORS_VARIATION_4,
  'variation-5': THEME_COLORS_VARIATION_5,
  'variation-6': THEME_COLORS_VARIATION_6,
} as const;

export type ThemeColorsVariations = typeof ThemeColorsVariations;

const ContrastRatio = {
  Element: 1.5,
  Text: 2.2,
  ButtonText: 2,
};

export const GlobalColorValues = {
  '--global-hue-offset': 0,
  '--global-saturation-multiplier': 1,
  '--global-lightness-multiplier': 1,
  '--global-darkening-amount': -10,
  '--global-lightening-amount': 10,
};

export const CONTRAST_CHECKS: Partial<Record<BaseThemeColorKey, [BaseThemeColorKey, number]>> = {
  [BaseThemeColorKey.SectionBackground]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionBackgroundTexture]: [BaseThemeColorKey.SectionBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionText]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionTextHeadline]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionTextBody]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionTextOverline]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.SectionTextByline]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.CardText]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.CardTextHeadline]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.CardTextBody]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  // button 1 background color determines text color
  [BaseThemeColorKey.ButtonPrimaryBackground]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Element],
  [BaseThemeColorKey.ButtonPrimaryText]: [BaseThemeColorKey.ButtonPrimaryBackground, ContrastRatio.ButtonText],
  // button 2 has a transparent background but is set to the same color as the section background
  [BaseThemeColorKey.ButtonSecondaryText]: [BaseThemeColorKey.ButtonSecondaryBackground, ContrastRatio.ButtonText],
  // button 3 text color determines background color
  [BaseThemeColorKey.ButtonTertiaryText]: [BaseThemeColorKey.BlockBackground, ContrastRatio.ButtonText],
  [BaseThemeColorKey.ButtonTertiaryBackground]: [BaseThemeColorKey.ButtonTertiaryText, ContrastRatio.ButtonText],
  [BaseThemeColorKey.NavigationText]: [BaseThemeColorKey.NavigationBackground, ContrastRatio.Text],
  [BaseThemeColorKey.Logo]: [BaseThemeColorKey.BlockBackground, ContrastRatio.Text],
  [BaseThemeColorKey.LogoNavigation]: [BaseThemeColorKey.NavigationBackground, ContrastRatio.Text],
};

// Currently derived colors are just a lightening/darkening of the base color, depending on whether the current
// lightness is above or below 50%. This is not a perfect solution, but it works for now. Tier2 and Tier3 colors
// will follow in the same direction as Tier1 colors (lighten or darken) by basing the css clamp value off of the
// original base color lightness. This should give at least a headroom of 50 for the shifting the lightness value.
// This is fine for now, because our steps are increments of 10 and there are only 3 steps. If we ever need more
// steps or higher step increments, we will need to revisit this as lightness is 0-100. Ideally, we would be able
// to generate a whole array of shades normalized based of perceived brightness, but this is all we need now.

export const TIER_1_DERIVED_THEME_COLORS: Tier1DerivedThemeColors = {
  [Tier1DerivedThemeColorKey.ButtonPrimaryBackgroundHover]: BaseThemeColorKey.ButtonPrimaryBackground,
  [Tier1DerivedThemeColorKey.ButtonPrimaryTextHover]: BaseThemeColorKey.ButtonPrimaryText,
  [Tier1DerivedThemeColorKey.ButtonSecondaryBackgroundHover]: BaseThemeColorKey.ButtonSecondaryBackground,
  [Tier1DerivedThemeColorKey.ButtonSecondaryTextHover]: BaseThemeColorKey.ButtonSecondaryText,
  [Tier1DerivedThemeColorKey.ButtonTertiaryBackgroundHover]: BaseThemeColorKey.ButtonTertiaryBackground,
  [Tier1DerivedThemeColorKey.ButtonTertiaryTextHover]: BaseThemeColorKey.ButtonTertiaryText,
  [Tier1DerivedThemeColorKey.MediaBackground]: BaseThemeColorKey.BlockBackground,
  [Tier1DerivedThemeColorKey.HighlightBackground]: BaseThemeColorKey.BlockBackground,
};

export const TIER_2_DERIVED_THEME_COLORS: Tier2DerivedThemeColors = {
  [Tier2DerivedThemeColorKey.MediaBackground2]: Tier1DerivedThemeColorKey.MediaBackground,
  [Tier2DerivedThemeColorKey.HighlightBackground2]: Tier1DerivedThemeColorKey.HighlightBackground,
};

export const TIER_3_DERIVED_THEME_COLORS: Tier3DerivedThemeColors = {
  [Tier3DerivedThemeColorKey.MediaBackground3]: Tier2DerivedThemeColorKey.MediaBackground2,
};
